import PliableLoader from "./PliableLoader.component";


export const FullPageLoader = () => {
    return (
        <div className="d-flex justify-content-center align-items-center" style={{height: '100vh'}}>
            <PliableLoader size='sm' />
        </div>
    );
}